const appleAuth = {}

export {
  appleAuth
}
